import { render, staticRenderFns } from "./uniquement-vos-dommages.vue?vue&type=template&id=6c3151a2&scoped=true"
import script from "./uniquement-vos-dommages.vue?vue&type=script&lang=ts"
export * from "./uniquement-vos-dommages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3151a2",
  null
  
)

export default component.exports